import { Announcement } from "./Announcement";
import { RFT_customer_appreciation } from "../../images";
import { Link, Typography } from "@mui/material";

export const CustAppreciationAnnouncement: React.FC<
    React.PropsWithChildren
> = () => {
    return (
        <Announcement
            startDate={new Date(2025, 4, 1)} //May 1, 2025 @ 00:00
            endDate={new Date(2025, 4, 23)} //Through May 23, 2025 @ 00:00
        >
            <Link
                href={RFT_customer_appreciation}
                target="_blank"
                underline="none"
            >
                <Typography sx={{ color: "white", fontSize: "1.25rem" }}>
                    Customer appreciation day is Thursday, May 22
                    <sup>nd</sup>! Click here for more details.
                </Typography>
            </Link>
        </Announcement>
    );
};
